export default "__VITE_ASSET__b0a1d5be__"